import { UsdcLogo } from 'assets/img';

export const currenciesImagesMock = {
  USDC: <UsdcLogo />,
};
